<template>
  <AuthLayout>
    <LoginFormAdmin />
  </AuthLayout>
</template>

<script setup>
import AuthLayout from "@/layouts/AuthLayout.vue";
import LoginFormAdmin from "@/components/LoginFormAdmin.vue";
</script>
